import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { Button, EditInput } from '@piplapps/pipl-ui';
import styles from './ProfileInformation.module.less';
import AnalyticsHandler from '../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../Utils/AnalyticsHandler/AnalyticsEventNames';

const ProfileInformation = (props) => {
  const { name, email, changeProfileDetails, isLoading } = props;
  const [success, setSuccess] = useState(false);

  const formatValues = (obj) => {
    const [first, ...rest] = obj.name.split(' ');

    return {
      first_name: first,
      last_name: rest.join(' '),
    };
  };

  const validate = (values) => {
    const errors = {};

    if (values.name === '') {
      errors.name = gettext('This field is required');
    }

    if (values.name) {
      const [first, last] = values.name.split(' ');

      if (!first || !last) {
        errors.name = gettext('Invalid full name');
      }
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      name: name || '',
    },
    validate,
    onSubmit: (values) => {
      values = formatValues(values);
      changeProfileDetails(values);
    },
  });

  useEffect(() => {
    formik.setFieldValue('name', props.name || formik.values.name || '');
  }, [props.name]);

  useEffect(() => {
    setSuccess(props.profileDetailsUpdateStatus);
  }, [props.profileDetailsUpdateStatus]);

  return (
    <div>
      <div>
        <div className={styles.topHeader}>{gettext('My profile')}</div>
        <div className={styles.header} id="page-title">
          {gettext('Profile Information')}
        </div>
        <div>
          <div className={styles.fieldsEdit} />
          <form onSubmit={formik.handleSubmit} id="profile-information-form">
            <div className={styles.emailHeader}>Email</div>
            <div className={styles.email}>{email || ''}</div>
            <EditInput
              label={gettext('Name')}
              id="name"
              name="name"
              testId="name-input"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
              error={formik.errors.name && formik.touched.name ? formik.errors.name : null}
            />
            <div className={styles.button}>
              <AnalyticsHandler
                eventName={AnalyticsEventNames.EDIT_PROFILE_NAME}
                eventData={{ profileName: formik.values.name, previousProfileName: name }}
              >
                <Button
                  type="submit"
                  text={gettext('Update name')}
                  buttonClass="primary-blue"
                  width="30%"
                  isLoading={isLoading}
                  disabled={!formik.isValid || formik.values.name === name}
                  loadingText={gettext('Updating')}
                />
              </AnalyticsHandler>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
ProfileInformation.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
  changeProfileDetails: PropTypes.func,
  profileDetailsUpdateStatus: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default ProfileInformation;
